import { put, takeEvery } from 'redux-saga/effects';
import { getLeadsPostcode } from '../../requests/get_address_lookup_request';
import { addressLookupRequestSuccess } from '../actions/address_lookup.actions';
import { ADDRESS_LOOKUP_REQUEST } from '../constants/address_lookup.constants';

function* addressLookupRequest({ data }) {
    const options = yield getLeadsPostcode(data);

    if (options.length) {
        yield put(addressLookupRequestSuccess(options));
    }
}

export default function* addressLookupSaga() {
    yield takeEvery(ADDRESS_LOOKUP_REQUEST, addressLookupRequest);
}



// WEBPACK FOOTER //
// ./src/modules/Leads/Lead_profile/redux/sagas/address_lookup.saga.js